<template>

  <div>
    <h2>{{ corectHeah.topic }}</h2>
    <span>总人数：{{ totalcount }}</span>
    <span id="span1">无成绩人数：{{ noperformance }}</span>
    <div id="main">


    </div>
  </div>


</template>

<script>
import earch from '@/components/work/until/Echarts.js'

export default {

  props: ['coretchList', 'corectHeah'],
  name: 'ViewExcelEcharts',
  data() {
    return {
      name: [],
      performance: [],
      totalcount: 0,
      noperformance: 0,
    }
  },
  methods: {

  },
  mounted() {
    this.totalcount = this.coretchList.length;
    let number = 0
    if (this.coretchList) {
      for (var i = 0; i < this.coretchList.length; i++) {
        this.name.push(this.coretchList[i].studentName);
        this.performance.push(this.coretchList[i].performance)

        if (this.coretchList[i].performance === null) {
          number++
        }
      }
      this.noperformance = number
    }

    var myChart = earch.init(document.getElementById('main'));
    myChart.setOption({
      title: {
        text: this.corectHeah.compositionNo
      },
      tooltip: {},
      xAxis: {
        data: this.name
      },
      yAxis: {},
      series: [
        {
          name: '销量',
          type: 'bar',
          data: this.performance
        }
      ]
    });

  }
}

</script>

<style scoped>
h2 {
  text-align: center;
  padding: 30px;
  font-size: 18px;
}

#main {
  width: 80%;
  height: 500px;
  border: 1px solid red;
  margin: 0 auto;
}

#span1 {
  padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/work/teacher/ViewExcelEcharts.vue